<script setup>
import { useStore } from 'vuex'
import FormRHDHV from '@/components/form/FormRHDHV.vue'
import SchematisationStageDoneButton from '@/components/schematisationDetail/SchematisationStageDoneButton.vue'
import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'

const URL = 'stab_schematisations'

const store = useStore()
const router = useRouter()

const form = ref(null)

const model = ref({ name: '' })
const order = ref(['name'])
const navigateToGeneratedSchema = ref(false)

const dialog = computed(() => store.state.reinforcement.dialog)
const currentItem = computed(() => store.state.reinforcement.currentItem)
const generateLoading = computed(() => store.state.reinforcement.generateLoading)

const currentStabSchematisationStage = computed(
  () => store.state.stabSchematisationStage.currentItem
)

const currentProject = computed(() => store.state.project.currentProject)

watch(dialog, () => {
  // Required otherwise the form will throw validation errors
  if (form.value) {
    form.value.resetValidation()
  }
})

const toggleDialog = () => store.dispatch('reinforcement/toggleDialog')
const generateNewSchema = (payload) => store.dispatch('reinforcement/generateNewSchema', payload)

const resetSchematisationChildrenState = () =>
  store.dispatch('stabSchematisation/resetChildrenState')
const resetSchematisationStageState = () => store.dispatch('stabSchematisationStage/resetState')

const close = () => {
  form.value.resetValidation()
  toggleDialog()
  form.value.clearModel()
}
const save = async (navigateToNewSchematisation = false) => {
  navigateToGeneratedSchema.value = navigateToNewSchematisation
  const isValid = form.value.save()
  if (isValid) {
    const newSchematisation = await generateNewSchema({
      reinforcementId: currentItem.value.id,
      name: model.value.name
    })
    close()
    if (navigateToNewSchematisation && newSchematisation) {
      await navigateToSchematisation(newSchematisation)
    }
  } else {
    console.log('Is not valid')
  }
}
const navigateToSchematisation = async (stabSchematisation) => {
  resetSchematisationChildrenState()
  resetSchematisationStageState()
  await router.push({
    name: 'schematisation-stage',
    params: {
      id: currentProject.value.id,
      revisionId: stabSchematisation.stage_configuration_revision.id,
      schematisationId: stabSchematisation.id,
      schematisationStageId: stabSchematisation.first_not_done_schematisation_stage
    }
  })
}
</script>

<template>
  <v-dialog v-model="dialog" max-width="500" @click:outside="close">
    <v-card>
      <v-card-title class="pt-4">Generate new schematisation</v-card-title>
      <v-card-text class="pl-0 pl-4">
        <div class="pb-3" v-if="!currentStabSchematisationStage.done">
          <v-alert type="warning" variant="tonal">
            The current stage is not done, please toggle this button
            <div class="pr-1 d-inline">
              <SchematisationStageDoneButton :item="currentStabSchematisationStage" />
            </div>
            generate a new schematisation
          </v-alert>
        </div>
        <FormRHDHV ref="form" :url="URL" :model="model" :formOrder="order" :dialog="dialog" />
      </v-card-text>
      <v-card-actions class="d-flex flex-column align-end">
        <v-btn
          color="primary"
          variant="text"
          @click="save()"
          :disabled="
            (generateLoading && navigateToGeneratedSchema) || !currentStabSchematisationStage.done
          "
          :loading="generateLoading && !navigateToGeneratedSchema"
        >
          Generate
        </v-btn>
        <v-btn
          class="mt-1"
          color="primary"
          variant="text"
          @click="save(true)"
          :disabled="
            (generateLoading && !navigateToGeneratedSchema) || !currentStabSchematisationStage.done
          "
          :loading="generateLoading && navigateToGeneratedSchema"
        >
          Generate & navigate
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
